import {
  AuthNetworkError,
  EmailNotVerifiedError,
  InvalidCredentialsError,
  InvalidPhoneNumberError,
  InvalidSecondFactorCodeError,
  SecondFactorInUseError,
  TooManyAttemptsError,
  TooManySecondFactorsError,
} from '@/auth/authErrors';
import { messages } from '@/i18n';

export const INPUT_CLASS =
  'border-border bg-secondary/40 focus-visible:ring-ring h-9 rounded-md border px-3 text-sm outline-none focus-visible:ring-2';

/** The copy for every error the MFA screens render in place. */
export function secondFactorErrorMessage(error: unknown): string {
  const t = messages.mfa.errors;
  if (error instanceof InvalidSecondFactorCodeError) return t.invalidCode;
  if (error instanceof TooManyAttemptsError) return t.tooManyAttempts;
  if (error instanceof InvalidPhoneNumberError) return t.invalidPhone;
  if (error instanceof SecondFactorInUseError) return t.phoneInUse;
  if (error instanceof TooManySecondFactorsError) return t.tooManyFactors;
  if (error instanceof EmailNotVerifiedError) return t.emailNotVerified;
  if (error instanceof InvalidCredentialsError) return t.wrongPassword;
  if (error instanceof AuthNetworkError) return t.network;
  return t.unavailable;
}

export function isCompleteCode(code: string): boolean {
  return /^\d{6}$/.test(code);
}

/** "+47 912 34 567" -> "+4791234567". Validation proper is the provider's. */
export function toE164(input: string): string {
  const trimmed = input.trim();
  const digits = trimmed.replace(/\D/g, '');
  return trimmed.startsWith('+') ? `+${digits}` : digits;
}
